import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import Image from "../../elements/image";
import Videojs from "../video-js";
// import SpinButton from "../../elements/spin-button";
import SuperButton from "../../elements/super-button";
import Heading from "../../elements/heading";
import { gtag } from "../../utils";

export default class HeroLanding extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = { openVideoTransition: false };
    this.updatePlayerInfo = this.updatePlayerInfo.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll = event => {
    let elem = this.refs.videoPlayer;
    if (elem === undefined) {
      return;
    }
    var rect = elem.getBoundingClientRect();

    if (
      !(
        (rect.top <= 0 && rect.bottom >= 0) ||
        (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) && rect.top <= (window.innerHeight || document.documentElement.clientHeight)) ||
        (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
      ) &&
      this.state.openVideoTransition
    ) {
      // this.setState({ openVideoTransition: false });
      this.closeVideo();
    }
  };

  updatePlayerInfo() {}

  pressPlay = () => {
    this.setState({ openVideoTransition: true });
    let that = this;
    setTimeout(function() {
      if (that.videoNode.videoNode.offsetWidth < 750) {
        that.videoNode.player.play();
      }
    }, 0);
  };
  closeVideo = () => {
    gtag('event', 'Component_info', {
      'component_name': 'HeroMedia',
      'page_title': this?.props?.page?.name
    });
    this.setState({ openVideoTransition: false });
  };
  endvideo = () => {
    this.setState({ openVideoTransition: false });
  };
  open() {
    if (this.state.openVideoTransition) {
      return "open";
    }
    return "";
  }
  onTransitionEnd() {
    if (this.state.openVideoTransition && this.props.fields && this.props.fields.videoAutoPlay && this.props.fields.videoAutoPlay.value) {
      this.videoNode.player.play();
    }
    if (this.videoNode) {
      this.videoNode.player.on("ended", this.endvideo);
    }
  }
  render() {
    if (!this.props.fields) return null;
    const {
      headingType,
      headingBody,
      alignment,
      backgroundColor,
      backgroundImage,
      backgroundAlign,
      image,
      video,
      videoCoverImage,
      // videoPlayButtonSize,
      // videoPlayText,
      // videoPlayButton,
      overline,
      body,
      bulletListItems,
      CTA,
      videoAutoPlay,
      sound
    } = this.props.fields;
    let headingTypeVal = headingType ? headingType : { fields: { key: { value: "span" }, phrase: { value: "span" } } };
    let divHeroBackgroundStyle = {};
    let divMediaBackgroundStyle = {
      "z-index": -1
    };

    if (backgroundColor) {
      divHeroBackgroundStyle = {
        background: backgroundColor ? backgroundColor.fields.phrase.value : ""
      };
    }

    if (backgroundImage.value && backgroundImage.value.src) {
      divHeroBackgroundStyle = {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.3) ), url(" + backgroundImage.value.src + ")"
      };
    }
    if (image.value && image.value.src) {
      divMediaBackgroundStyle = {
        backgroundImage: " url(" + image.value.src + ")",
        background: "linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.3) ), url(" + image.value.src + ")"
      };
    }
    if (video.value && video.value.src && videoCoverImage.value && videoCoverImage.value.src) {
      divMediaBackgroundStyle = {
        backgroundImage: " url(" + videoCoverImage.value.src + ")",
        background: "linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.3) ), url(" + videoCoverImage.value.src + ")"
      };
    }

    const mediaClasses = classNames("media-content ", {
      open: this.state.openVideoTransition
    });
    const heroClasses = classNames(
      "hero-landing",
      {
        grid: alignment && alignment.fields && alignment.fields.phrase.value === "center",
        "has-media": (video.value && video.value.src) || (image.value && image.value.src)
      },
      backgroundAlign ? `bg-${backgroundAlign.fields.phrase.value}` : ""
    );

    const alignClass = classNames("full-width", {
      center: alignment && alignment.fields && alignment.fields.phrase.value === "center",
      grid: alignment && alignment.fields && alignment.fields.phrase.value !== "center",
      right: alignment && alignment.fields && alignment.fields.phrase.value === "right",
      fadeout: this.state.openVideoTransition
    });

    const h2Classes = classNames("big-title", {
      "extra-padding": (video.value && video.value.src) || (image.value && image.value.src)
    });

    const videoClass = classNames("video-wrapper", {
      fadein: this.state.openVideoTransition
    });
    // const spinButtonObj = {
    //   size: videoPlayButtonSize ? videoPlayButtonSize.fields.phrase.value : "",
    //   text: videoPlayText.value,
    //   icon: {
    //     value:
    //       (videoPlayButton &&
    //         videoPlayButton.value &&
    //         videoPlayButton.value.alt) ||
    //       ""
    //   }
    // };
    return (
      <div className={heroClasses} style={divHeroBackgroundStyle} datasourceid={this.props.rendering ? this.props.rendering.dataSource : undefined}>
        <div className={alignClass}>
          {overline && overline.value !== "" && <span className="overline">{overline.value}</span>}

          <Heading
            {...{
              type: headingTypeVal,
              html: headingBody
            }}
            className={h2Classes}
          />

          {body && <RichText tag="div" className="body-text" field={body} />}
          {bulletListItems && bulletListItems.length > 0 && (
            <div className={"body-text"}>
              <ul>
                {bulletListItems.map((item, index) => {
                  return (
                    <li key={index}>
                      {item.fields.iconName && item.fields.iconName.value && item.fields.iconName.value.alt && <RichText field={{ value: item.fields.iconName.value.alt }} />}
                      {item.fields.body && item.fields.body.value}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="button-container">{CTA && CTA.length > 0 && CTA.map((item, index) => item.fields && item.fields.ctatype && item.fields.ctatype.fields && <SuperButton key={index} {...item.fields} />)}</div>
          {((video.value && video.value.src) || (image.value && image.value.src)) && (
            <div className={"media-container"}>
              <div className={mediaClasses} style={divMediaBackgroundStyle} onTransitionEnd={this.onTransitionEnd.bind(this)}>
                {image.value && image.value.src && !videoCoverImage.value.src && <Image {...image.value} />}
                {videoCoverImage.value && videoCoverImage.value.src && <Image {...videoCoverImage.value} />}
              </div>
            </div>
          )}

          {video.value && video.value.src && (
            <div className={videoClass} ref={"videoPlayer"}>
              <div className="top">
                <span className="close" onClick={this.closeVideo} />
              </div>
              <Videojs
                ref={e => (this.videoNode = e)}
                {...{
                  sources: [
                    {
                      src: video.value.src,
                      type: video.value.mimeType
                    }
                  ],
                  controls: true,
                  autoplay: videoAutoPlay.value,
                  muted: sound.value,
                  poster: videoCoverImage.value ? videoCoverImage.value.src : ""
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
